// @flow
import * as React from 'react';
// eslint-disable-next-line import/named
import { type IntlShape } from 'react-intl';

// Components
import { Row, Col } from 'reactstrap';
import Panel from 'components/atoms/Panel';
import VehicleImageWithPlaceholder from 'components/atoms/VehicleImageWithPlaceholder';

// Utils
import { getVehicleImgUrl } from 'utils/media';
import { isToday, formatTime } from 'utils/date';
import { getMMLabel } from 'utils/string';

// Types
import { type VehicleInfo } from 'api/xws/statusTracker/statusTrackerWs';

import './VehiclePanelWithGrayOut.scss';

const ns = 'vehicle-panel-with-gray-out';

export type Props = {
  intl: IntlShape,
  vehicleInfo?: VehicleInfo,
  dealerCountryCode: string,
  addMask: boolean,
  startTime: Object,
  modelLabelOther?: string,
  makeLabelOther?: string
};

const VehiclePanelWithGrayOut = ({
  vehicleInfo,
  addMask,
  dealerCountryCode,
  startTime,
  intl,
  modelLabelOther,
  makeLabelOther
}: Props) => {
  const labelTime = formatTime((startTime || '').toString(), intl);
  const labelDate = intl.formatDate(startTime, {
    month: 'long',
    day: 'numeric',
    weekday: 'short'
  });

  // @TODO: remove defaultMessage when localization string is ready
  const todayLabel = intl.formatMessage({
    id: 'c8.self.check.in.vehicle.panel.today.at',
    defaultMessage: `Today at`
  });
  const notTodayLabel = intl.formatMessage(
    {
      id: 'c8.self.check.in.vehicle.panel.future.date.at',
      defaultMessage: `${labelDate} at`
    },
    {
      labelDate
    }
  );

  const date = isToday(startTime) ? todayLabel : notTodayLabel;
  const time = startTime ? `${date} ${labelTime}` : '';
  return (
    <Row className={`${ns} mx-0`}>
      <Panel className={`${ns}__panel m-0`}>
        <Col xs={3} className={`${ns}__vehicle p-0`}>
          <VehicleImageWithPlaceholder
            src={getVehicleImgUrl(vehicleInfo, dealerCountryCode)}
          />
          {addMask && <div className={`${ns}__vehicle vehicle-mask`} />}
        </Col>
        <Col xs={9}>
          <div className={`${ns}__info-vehicle`}>
            <span className={`mr-1`}>
              {vehicleInfo && vehicleInfo.year}{' '}
              {vehicleInfo &&
                getMMLabel(vehicleInfo.make, makeLabelOther, intl)}
            </span>
            <span className={`${ns}__info-vehicle--model`}>
              {vehicleInfo &&
                getMMLabel(vehicleInfo.model, modelLabelOther, intl)}
            </span>
          </div>
          <div className={`${ns}__info-text`}>{time}</div>
        </Col>
      </Panel>
    </Row>
  );
};

VehiclePanelWithGrayOut.defaultProps = {
  vehicleInfo: {
    year: null,
    make: null,
    model: null
  }
};

export default VehiclePanelWithGrayOut;



// WEBPACK FOOTER //
// ./src/components/atoms/VehiclePanelWithGrayOut/VehiclePanelWithGrayOut.js